/* Lagom cookie consent (GDPR / ePrivacy, IMY). Shopify: assets/cookie-consent.js, markup in snippets/cookie-consent.liquid.
   - Two buttons on the first layer: "Customize" (left) opens a second layer, "Accept all" (right). The second layer
     (as on tradera.com): "You allow" Deny / Allow for every category at once, then Necessary (always on), Analytics
     and Marketing, each with a "+" for its description and its own Deny / Allow, nothing chosen at first (the footer
     link shows the visitor's current choice). Below: "Deny all", "Accept all", and "Save choices", which opens up
     once every category has an answer. Marketing is hidden when no pixels are used.
   - Nothing non-essential runs before consent: loadConsentedScripts() injects Microsoft Clarity only when analytics is
     allowed, on load (returning visitors) and right after a choice. Ignoring the banner is not consent.
   - The choice goes through Shopify's Customer Privacy API (window.Shopify.customerPrivacy) when it exists; the static
     prototype falls back to localStorage (kept 6 months).
   - Not a modal: no focus trap, the page stays usable. Esc closes the Customize layer only.
   - Appears 1.5 s after load or on the first scroll, whichever comes first. Hidden in ?capture=1.
   - Counts consent_accept_all / consent_necessary_only / consent_customize_saved / consent_ignored (no choice within
     60 s) without cookies: Shopify.analytics.publish when available, else a sendBeacon to data-cc-count-url (if set).
   - Copy A/B test: data-cc-variant-b-title / -body (theme setting); 50/50, remembered in sessionStorage only. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cc]');
  if (!root) { return; }

  var CAPTURE = /[?&]capture=1(?:&|$)/.test(location.search);
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STORE = 'lagom-consent', SIX_MONTHS = 1000 * 60 * 60 * 24 * 182;
  var MARKETING = root.getAttribute('data-cc-marketing') === 'true';   // theme setting: are marketing pixels in use?
  var CLARITY_ID = root.getAttribute('data-cc-clarity-id') || document.documentElement.getAttribute('data-clarity-id') || '';
  var COUNT_URL = root.getAttribute('data-cc-count-url') || 'https://lagom-requests.fly.dev/consent';

  /* ---------- texts (the prototype translates itself; in Shopify the snippet renders the locale strings) ---------- */
  var T = {
    en: {
      title: 'Help us make Lagom better',
      body: 'We use cookies to see which parts of the site help people and which confuse them. You can change your mind anytime.',
      bodyAds: ' We also use them to show you relevant ads.',
      accept: 'Accept all', necessary: 'Only necessary', customize: 'Customize', more: 'Read more',
      save: 'Save choices', nec: 'Necessary', necD: 'Cart, checkout and security.', ana: 'Analytics',
      anaD: 'Helps us improve the site (Microsoft Clarity, Shopify analytics).', mkt: 'Marketing', mktD: 'Measures our ads.',
      always: 'Always on', settings: 'Cookie settings', label: 'Cookie consent'
    },
    sv: {
      title: 'Hjälp oss göra Lagom bättre',
      body: 'Vi använder cookies för att se vilka delar av sidan som hjälper och vilka som förvirrar. Du kan ändra dig när som helst.',
      bodyAds: ' Vi använder dem också för att visa relevanta annonser.',
      accept: 'Godkänn alla', necessary: 'Endast nödvändiga', customize: 'Anpassa', more: 'Läs mer',
      save: 'Spara val', nec: 'Nödvändiga', necD: 'Varukorg, kassa och säkerhet.', ana: 'Analys',
      anaD: 'Hjälper oss förbättra sidan (Microsoft Clarity, Shopify-analys).', mkt: 'Marknadsföring', mktD: 'Mäter våra annonser.',
      always: 'Alltid på', settings: 'Cookie-inställningar', label: 'Samtycke till cookies'
    }
  };
  var lang = (/^\/sv(\/|$)/.test(location.pathname) || /[?&]lang=sv(?:&|$)/.test(location.search) || /^sv/i.test(document.documentElement.lang)) ? 'sv' : 'en';
  var S = T[lang];
  if (root.getAttribute('data-cc-i18n') !== 'off') {   // Shopify renders translated text and sets data-cc-i18n="off"
    root.querySelectorAll('[data-cc-t]').forEach(function (el) { el.textContent = S[el.getAttribute('data-cc-t')]; });
    document.querySelectorAll('[data-cc-open]').forEach(function (el) { el.textContent = S.settings; });
    root.setAttribute('aria-label', S.label);
    if (lang === 'sv') { root.setAttribute('lang', 'sv'); }
  }
  /* Copy test: variant B from the theme settings, 50/50 per session. */
  var vbTitle = root.getAttribute('data-cc-variant-b-title'), vbBody = root.getAttribute('data-cc-variant-b-body'), variant = 'a';
  if (vbTitle && vbBody) {
    try { variant = sessionStorage.getItem('lagom-cc-variant') || (Math.random() < 0.5 ? 'a' : 'b'); sessionStorage.setItem('lagom-cc-variant', variant); } catch (e) { variant = 'a'; }
    if (variant === 'b') { root.querySelector('[data-cc-t="title"]').textContent = vbTitle; root.querySelector('[data-cc-t="body"]').textContent = vbBody; }
  }
  if (MARKETING) { var b = root.querySelector('[data-cc-t="body"]'); b.textContent += root.getAttribute('data-cc-body-ads') || S.bodyAds; }
  else { var row = root.querySelector('[data-cc-row="marketing"]'); if (row) { row.remove(); } }

  /* ---------- storage: Shopify's API, or localStorage in the prototype ---------- */
  function api() { return window.Shopify && window.Shopify.customerPrivacy; }
  function local() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (v && Date.now() - v.ts < SIX_MONTHS) { return v; }
    } catch (e) { /* blocked storage: ask again */ }
    return null;
  }
  function decided() {
    var p = api();
    if (p) {
      var c = p.currentVisitorConsent ? p.currentVisitorConsent() : {};
      return !!(c && (c.analytics === 'yes' || c.analytics === 'no'));
    }
    return !!local();
  }
  function analyticsOK() { var p = api(); if (p) { return !!p.analyticsProcessingAllowed(); } var v = local(); return !!(v && v.analytics); }
  function marketingOK() { var p = api(); if (p) { return !!p.marketingAllowed(); } var v = local(); return !!(v && v.marketing); }
  function shouldShow() { var p = api(); if (p && p.shouldShowBanner) { return p.shouldShowBanner() && !decided(); } return !decided(); }
  function save(analytics, marketing, done) {
    var choice = { analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: marketing };
    var p = api();
    if (p && p.setTrackingConsent) { p.setTrackingConsent(choice, function () { if (done) { done(); } }); return; }
    try { localStorage.setItem(STORE, JSON.stringify({ analytics: analytics, marketing: marketing, ts: Date.now() })); } catch (e) { /* this visit only */ }
    document.dispatchEvent(new CustomEvent('visitorConsentCollected', { detail: choice }));
    if (done) { done(); }
  }

  /* ---------- trackers, only after consent ---------- */
  var clarityOn = false;
  function loadConsentedScripts() {
    if (analyticsOK() && CLARITY_ID && !clarityOn) {
      clarityOn = true;
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', CLARITY_ID);
      window.clarity('consent');
      /* Tag sessions with the theme (and language) so Clarity can filter them by theme. */
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.name) { window.clarity('set', 'theme', th.name); }
        if (window.Shopify && window.Shopify.locale) { window.clarity('set', 'language', window.Shopify.locale); }
        var ref = sessionStorage.getItem('lagom_ref');   /* the outside referrer before the language redirect (lang-redirect.liquid) */
        if (ref) { window.clarity('set', 'landing_referrer', ref); }
      } catch (e) { /* ignore */ }
    }
    if (marketingOK()) {
      /* Marketing pixels: install them through Shopify customer events / apps (they respect consent on their own).
         Anything that must be injected here goes in this branch. */
    }
  }
  window.loadConsentedScripts = loadConsentedScripts;
  document.addEventListener('visitorConsentCollected', loadConsentedScripts);

  /* ---------- consent-free counting ---------- */
  function count(name) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) { window.Shopify.analytics.publish(name, { variant: variant }); }
      /* Counted by the Lagom Requests app (Shopify admin > Apps > Cookie banner): text/plain JSON, no cookies. */
      if (COUNT_URL && navigator.sendBeacon) {
        navigator.sendBeacon(COUNT_URL, JSON.stringify({ event: name, variant: variant, source: source, locale: document.documentElement.lang || lang }));
      }
    } catch (e) { /* counting never breaks the banner */ }
  }

  /* ---------- the banner ---------- */
  var more = root.querySelector('[data-cc-more]'), panel = root.querySelector('[data-cc-panel]');
  var saveBtn = root.querySelector('[data-cc-action="save"]'), hint = root.querySelector('[data-cc-hint]');
  var ignoreTimer = 0, shown = false, source = 'banner';
  /* Per category: true (allow), false (deny) or null (not chosen yet). */
  function cats() { return Array.prototype.slice.call(root.querySelectorAll('[data-cc-cat]')); }
  function getChoice(name) {
    var row = root.querySelector('[data-cc-cat="' + name + '"]'); if (!row) { return false; }
    var v = row.getAttribute('data-cc-value'); return v === 'yes' ? true : v === 'no' ? false : null;
  }
  function setChoice(row, v) {
    if (v === null) { row.removeAttribute('data-cc-value'); } else { row.setAttribute('data-cc-value', v ? 'yes' : 'no'); }
    row.querySelectorAll('[data-cc-choice]').forEach(function (b) {
      b.setAttribute('aria-pressed', v !== null && (b.getAttribute('data-cc-choice') === 'yes') === v ? 'true' : 'false');
    });
    var list = cats(), all = list.every(function (r) { return r.hasAttribute('data-cc-value'); });
    if (saveBtn) { saveBtn.disabled = !all; }
    if (hint) { hint.hidden = all; }
  }
  function changed() { document.dispatchEvent(new CustomEvent('lagom:cookie-changed')); }
  function show(fromLink) {
    if (shown) { return; }
    shown = true; source = fromLink ? 'settings' : 'banner';
    if (!fromLink) { count('consent_shown'); }
    cats().forEach(function (r) {
      var name = r.getAttribute('data-cc-cat');
      setChoice(r, fromLink && decided() ? (name === 'marketing' ? marketingOK() : analyticsOK()) : null);
    });
    expand(false);
    root.hidden = false;
    root.classList.toggle('is-still', REDUCE);
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); changed(); }); });
    if (!fromLink) { ignoreTimer = window.setTimeout(function () { if (shown) { count('consent_ignored'); } }, 60000); }
  }
  function hide() {
    shown = false; window.clearTimeout(ignoreTimer);
    root.classList.remove('is-in');
    window.setTimeout(function () { if (!shown) { root.hidden = true; changed(); document.dispatchEvent(new CustomEvent('lagom:cookie-closed')); } }, REDUCE ? 0 : 300);
  }
  function expand(open) {
    root.classList.toggle('is-custom', open);
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) { panel.removeAttribute('inert'); } else { panel.setAttribute('inert', ''); }
  }
  function decide(analytics, marketing, event) { save(analytics, marketing, function () { count(event); hide(); }); }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cc-action], [data-cc-choice], [data-cc-all], [data-cc-expand]');
    if (!t) { return; }
    if (t.hasAttribute('data-cc-expand')) {
      var open = t.getAttribute('aria-expanded') !== 'true', d = document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-expanded', open ? 'true' : 'false'); if (d) { d.hidden = !open; } return;
    }
    if (t.hasAttribute('data-cc-choice')) { setChoice(t.closest('[data-cc-cat]'), t.getAttribute('data-cc-choice') === 'yes'); return; }
    if (t.hasAttribute('data-cc-all')) { var yes = t.getAttribute('data-cc-all') === 'yes'; cats().forEach(function (r) { setChoice(r, yes); }); return; }
    var a = t.getAttribute('data-cc-action');
    if (a === 'accept') { decide(true, MARKETING, 'consent_accept_all'); }
    if (a === 'necessary') { decide(false, false, 'consent_necessary_only'); }
    if (a === 'save' && !t.disabled) { decide(getChoice('analytics') === true, MARKETING && getChoice('marketing') === true, 'consent_customize_saved'); }
    if (a === 'customize') {
      expand(!root.classList.contains('is-custom'));
      /* Keyboard users (Enter/Space: e.detail is 0) land on the first choice; a tap leaves the focus where it was. */
      var first = root.querySelector('[data-cc-all]'); if (root.classList.contains('is-custom') && first && e.detail === 0) { first.focus({ preventScroll: true }); }
    }
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-custom')) { e.stopPropagation(); expand(false); more.focus(); }
  });
  /* "Cookie settings" in the footer reopens it, with the current choice filled in. */
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('[data-cc-open]');
    if (!l) { return; }
    e.preventDefault(); shown = false; show(true); expand(true);
    var f = root.querySelector('[data-cc-action="accept"]'); if (f) { f.focus({ preventScroll: true }); }
  });

  function start() {
    loadConsentedScripts();   // returning visitors who already said yes
    if (CAPTURE || !shouldShow()) { return; }
    var go = function () { window.removeEventListener('scroll', go); window.clearTimeout(t); show(false); };
    var t = window.setTimeout(go, 1500);
    window.addEventListener('scroll', go, { passive: true, once: true });
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err) { /* API unavailable: fall back */ } start(); });
  } else { start(); }
})();
